module.exports = __webpack_public_path__ + "img/HealArea.0abaf818.webp";